import { Drawer } from '@hyperflake/react-ui-library';
import { Button } from '@library/buttons';
import { Label } from '@library/forms';
import { Formik, Form, Field } from 'formik';
import FormikTextarea from 'modules/shared/features/formik/components/FormikTextarea/FormikTextarea';
import * as Yup from 'yup';

interface RemarkSiteRecceDrawerProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (remarks: string) => void;
}

const RemarkSiteRecceDrawer = ({ open, onClose, onSubmit }: RemarkSiteRecceDrawerProps) => {
    const schema = Yup.object().shape({
        remarks: Yup.string().required('Completion Remarks is required'),
    });

    return (
        <Drawer open={open} onClose={onClose} title="Add Remarks">
            <Formik
                initialValues={{ remarks: '' }}
                validationSchema={schema}
                onSubmit={(values) => {
                    onSubmit(values.remarks);
                    onClose();
                }}
            >
                {({ errors, touched }) => (
                    <Form>
                        <div>
                            <Label className="block text-sm font-medium text-gray-700 mb-1">Remarks</Label>
                            <FormikTextarea name="remarks" rows={4} className="w-full" placeholder="Enter Remarks" />
                            {errors.remarks && touched.remarks && (
                                <div className="text-red-500 text-sm mt-1">{errors.remarks}</div>
                            )}
                        </div>
                        <div className="flex gap-4 mt-4">
                            <Button type="submit">Add</Button>
                            <Button variant="outlined" type="button" onClick={onClose}>
                                Cancel
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </Drawer>
    );
};

export default RemarkSiteRecceDrawer;
